<template>
  <v-app>
    <ApplicationSideBar />
    <router-view name="toolbar" />
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import ApplicationSideBar from '../components/layout/ApplicationSideBar'

export default {
  name: 'Application',
  components: {
    ApplicationSideBar
  }
}
</script>
